import MuiTablePagination, { TablePaginationProps } from '@material-ui/core/TablePagination';

export type DSTablePaginationProps = TablePaginationProps;

export const DSTablePagination = MuiTablePagination;
